// Record ids are GUIDs (strings such as "3f2a9c1e-…"), not integers.
//
// "No id" is null. The integer-era spellings of "none" — 0, "0", "" and undefined — still turn
// up in form state and in older saved drafts, so toId() folds all of them, and the all-zero
// GUID, into null. The API reads null as "no id" in the same way.
//
// Never pass an id through Number() or parseInt(): a GUID becomes NaN, which serialises to
// null and silently turns "update this record" into "create a new one".
const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

export const toId = (v) => {
  if (v === null || v === undefined) return null;
  const s = String(v).trim();
  return s === "" || s === "0" || s === EMPTY_GUID ? null : s;
};

export const toIds = (list) => (Array.isArray(list) ? list.map(toId).filter(Boolean) : []);

// GUIDs compare case-insensitively; the API sends lower case but a pasted or stored one may not be.
export const sameId = (a, b) => {
  const x = toId(a);
  const y = toId(b);
  return x !== null && y !== null && x.toLowerCase() === y.toLowerCase();
};
